package com.parmartechnologies.core.feature.employee.network

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class FindEmployeeRequest(
    @SerialName("user_id") val UserID: String,
    @SerialName("mobile_number") val MobileNumber: String,
    @SerialName("dial_code") val dialCode: String,
)

@Serializable
data class FindUserRequest(
    @SerialName("user_id") val UserID: String,
    @SerialName("mobile_number") val mobile: String,
    @SerialName("dial_code") val dialCode: String,
)

@Serializable
data class FetchEmployeeRequest(
    @SerialName("user_id") val UserID: String,
    @SerialName("LastSyncDate") val LastSyncDate: String
)

@Serializable
data class FetchBusinessEmployeeRequest(
    @SerialName("business_id") val BusinessID: String,
    @SerialName("LastSyncDate") val LastSyncDate: String
)

@Serializable
data class CreateEmployeeRequest(
    @SerialName("user_id") val UserID: String,
    @SerialName("business_id") val BusinessID: String,
    @SerialName("employee_user_id") var EmployeeUserID: String,
    @SerialName("name") var Name: String,
    @SerialName("address") var Address: String,
    @SerialName("status") var Status: String,
    @SerialName("email_id") var EmailID: String,
    @SerialName("mobile_number") val MobileNumber: String,
    @SerialName("dial_code") val dialCode: String,
    @SerialName("whatsapp") var WhatsApp: String,
    @SerialName("gender") var Gender: Int,
    @SerialName("device_id") var DeviceID: String,
    @SerialName("fcm_token") var FCMToken: String,
    @SerialName("job_type_id") var JobTypeId: String,
    @SerialName("job_type_name") var JobTypeName: String,
)

@Serializable
data class UpdateEmployeeRequest(
    @SerialName("_id") val id: String,
    @SerialName("user_id") val UserID: String,
    @SerialName("business_id") val BusinessID: String,
    @SerialName("name") val name: String,
    @SerialName("dial_code") val dialCode: String,
    @SerialName("mobile_number") val mobile: String,
    @SerialName("email_id") val email: String,
    @SerialName("device_id") val deviceID: String,
    @SerialName("is_deleted") var IsDeleted: Int,
    @SerialName("job_type_id") var JobTypeId: String,
    @SerialName("job_type_name") var JobTypeName: String,
)
@Serializable
data class RetrieveBusinessEmployeeRequest(
    @SerialName("business_id") val BusinessID: String,
    @SerialName("LastSyncDate") val lastSyncDate: String
)